// Shows each dish's variant choice (size, sauce) as tap buttons. The <select data-tgv-variant-select> stays in the
// page as the source of truth, so date-first logic, validation and add-to-cart read it as before. Without JS the
// select is simply visible. Buttons mirror the select's selected value and each option's disabled state.
const enhance = select => {
  if (select.dataset.tgvEnhanced) return;
  select.dataset.tgvEnhanced = 'true';
  const order = select.closest('[data-menu-order]');
  const label = order && order.querySelector(`label[for="${select.id}"]`);
  const group = document.createElement('div');
  group.className = 'tgv__variants';
  group.setAttribute('role', 'group');
  if (label) group.setAttribute('aria-labelledby', (label.id = label.id || `${select.id}-label`));
  const buttons = [];
  for (const option of select.options) {
    if (!option.value) continue;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'tgv__variant';
    button.dataset.value = option.value;
    button.textContent = option.textContent;
    button.addEventListener('click', () => {
      if (button.disabled) return;
      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
    buttons.push(button);
    group.append(button);
  }
  const sync = () => {
    for (const button of buttons) {
      const option = [...select.options].find(item => item.value === button.dataset.value);
      button.disabled = !option || option.disabled;
      button.setAttribute('aria-pressed', String(select.value === button.dataset.value));
    }
  };
  select.addEventListener('change', sync);
  new MutationObserver(sync).observe(select, { attributes: true, subtree: true, attributeFilter: ['disabled'] });
  select.after(group);
  order.classList.add('tgv__order--buttons');
  sync();
};
const run = () => document.querySelectorAll('[data-tgv-variant-select]').forEach(enhance);
run();
new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
